import { useTheme, darken, lighten } from "../libraries/material/styles"

const convertColor = ({ invert, colorCode, darkMode, getContrastText }) => {
  let colors = {
    saturated: darken(colorCode, 0.2), 
    border: colorCode, 
    contrast: lighten(colorCode, .9),
    background: "",
    text: ""
  }
  colors.background = lighten(colors.contrast, 0.6);
  
  if (invert) {
    colors.contrast = !darkMode 
      ? darken(colorCode, 0.5)
      : darken(colorCode, 0.8)
    colors.saturated = !darkMode 
      ? lighten(colorCode, 0.95)
      : lighten(colorCode, 0.5)
    colors.border = colorCode
  } else if(darkMode) {
    colors.contrast = darken(colorCode, 0.9);
    colors.saturated = lighten(colorCode, 0.4);
    colors.background = darken(colors.contrast, 0.6);
  } 

  colors.text = colors.background && getContrastText(colors.background)

  return colors
}

const useColors = ({ color = "", invert }) => {
  const theme = useTheme();
  const darkMode = theme.palette.type === "dark";
  let colorCode = theme.palette.colors[color];
  if(!colorCode) {
    colorCode = theme.palette.colors.gray
  }
  
  return convertColor({
    invert,
    colorCode,
    darkMode,
    getContrastText: theme.palette.getContrastText
  })
}

export default useColors